import { render } from "./RegisterUserView.vue?vue&type=template&id=37ad3266&scoped=true"
import script from "./RegisterUserView.vue?vue&type=script&lang=js"
export * from "./RegisterUserView.vue?vue&type=script&lang=js"

import "./RegisterUserView.vue?vue&type=style&index=0&id=37ad3266&scoped=true&lang=css"

import exportComponent from "/Users/daniel/Documents/CETECREA/cetecrea/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ad3266"]])

export default __exports__